import React from 'react';

import CardHolderList from '../../components/Admin/CardHolderList';

function CardHolderListView() {
  return (
    <CardHolderList />
  );
}

export default CardHolderListView;
